import React from 'react';
import { motion } from 'framer-motion';
import { precisionPrinciples, principles, snak3Images } from '../../../data/snak3';
const EASE = [0.23, 1, 0.32, 1] as const;
export function PrinciplesScreen() {
  return <div className="flex flex-1 flex-col" data-id="element-807" data-mp="i1ocra9aycnm">
      <motion.figure initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 0.3,
      ease: EASE
    }} className="relative -mx-6 -mt-3" data-id="element-808" data-mp="i2prbopj1ha3">
        <img src={snak3Images.retinaAI.src} alt={snak3Images.retinaAI.alt} draggable={false} className="h-[188px] w-full select-none object-cover" data-id="element-809" data-mp="1aoisjtv6cnur" />
        <figcaption className="absolute left-0 top-4 bg-ozGreen px-3 py-1 text-[9px] font-semibold uppercase tracking-micro text-ozNavy" data-id="element-810" data-mp="10xo9eyd864dj">
          {principles.eyebrow}
        </figcaption>
        <motion.h2 initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.08,
        ease: EASE
      }} className="absolute inset-x-0 bottom-0 bg-ozNavy/85 px-6 py-3 font-display text-[25px] font-bold uppercase leading-[0.98] tracking-tight text-paper" data-id="element-811" data-mp="1thcyxzeqf7nd">
          {principles.headline[0]}
          <span className="mt-0.5 block text-ozGreen" data-id="element-812" data-mp="3ne8nhq4p1ajs">{principles.headline[1]}</span>
        </motion.h2>
      </motion.figure>

      <p className="mt-5 text-[12.5px] leading-relaxed text-paper/70" data-id="element-813" data-mp="3scsbdw2ukwes">{principles.lead}</p>

      <ul className="mt-5 flex flex-col gap-2" data-id="element-814" data-mp="3ed0pl963abq8">
        {precisionPrinciples.map((principle, i) => {
        const isLast = i === precisionPrinciples.length - 1;
        return <motion.li key={principle.label} initial={{
          opacity: 0,
          x: -6
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.24,
          delay: 0.1 + i * 0.06,
          ease: EASE
        }} className={`rounded-xl px-4 py-3 ${isLast ? 'bg-ozGreen' : 'border-l-[3px] border-ozGreen/70 bg-paper/[0.07]'}`} data-id="element-815" data-mp="34hfr3l08btl8" data-mpi={i}>
              <p className={`font-display text-[14px] font-bold uppercase leading-none tracking-tight ${isLast ? 'text-ozNavy' : 'text-paper'}`} data-id="element-816" data-mp="167qeern7ajy8">
                {principle.label}
              </p>
              <p className={`mt-1.5 text-[11.5px] leading-snug ${isLast ? 'text-ozNavy/80' : 'text-paper/60'}`} data-id="element-817" data-mp="ra7tk0dn8qw2">
                {principle.already}
              </p>
            </motion.li>;
      })}
      </ul>

      <motion.p initial={{
      opacity: 0,
      y: 8
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.26,
      delay: 0.4,
      ease: EASE
    }} className="mt-auto pt-5 font-display text-[21px] font-semibold leading-snug text-paper" data-id="element-818" data-mp="1f7n6z4cpo2yk">
        {principles.takeaway}
      </motion.p>
    </div>;
}